import { render, staticRenderFns } from "./DecorPageList.vue?vue&type=template&id=24694b64&scoped=true"
import script from "./DecorPageList.vue?vue&type=script&lang=js"
export * from "./DecorPageList.vue?vue&type=script&lang=js"
import style0 from "./DecorPageList.vue?vue&type=style&index=0&id=24694b64&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24694b64",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JSH_ERP\\JSH_ERP\\mgerpweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24694b64')) {
      api.createRecord('24694b64', component.options)
    } else {
      api.reload('24694b64', component.options)
    }
    module.hot.accept("./DecorPageList.vue?vue&type=template&id=24694b64&scoped=true", function () {
      api.rerender('24694b64', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/plugin/dining/decor/DecorPageList.vue"
export default component.exports